// extracted by mini-css-extract-plugin
export default {"breadcrumb":"ControllerConfigPage_breadcrumb__D9XTw"};